"use client";

import { motion } from "motion/react";
import Image from "next/image";
import Reveal from "../../enterprise/components/Reveal";
import { useTranslations } from "next-intl";

const VotingSection = () => {
  const t = useTranslations("governance");
  return (
    <section className="mx-auto flex max-w-[1440px] bg-[#e8f0ff]/10 px-[78px] py-20 max-lg:px-10 max-md:flex-col max-md:gap-12 max-sm:px-4">
      <div className="w-1/2 max-md:w-full">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="text-[48px]/[56px] tracking-[-1px] text-[#202020] max-lg:text-3xl">
            {/* {t("your")} <span className="text-[#06f]">{t("vote")}</span>.{" "}
            {t("your")} <span className="text-[#06f]">{t("power")}</span> */}
            {t.rich("your-vote-your-power", {
              blue: (children) => <span className="text-[#06f]">{children}</span>,
            })}
          </h2>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-6 text-base font-light text-[#646464] max-lg:text-base">
            {t(
              "hyra-network-is-governed-by-a-decentralized-autonomous-organization-dao-legally-represented-by-the-hyra-foundation-a-non-profit-entity-registered-in-zug-switzerland",
            )}
          </p>
        </Reveal>
        <div className="mt-14 flex items-end gap-3">
          {/* <div className="bg-[url('/images/backgrounds/button-gov.svg')] bg-cover bg-no-repeat w-[186px] h-[215px] p-5 flex-col justify-between rounded-[8px]"> */}
          <motion.div
            initial={{ clipPath: "inset(100% 0 0 0)" }} // che từ dưới lên
            animate={{ clipPath: "inset(0% 0 0 0)" }} // bung ra toàn phần
            transition={{
              delay: 0,
              duration: 1,
              ease: [0.25, 0.46, 0.45, 0.94],
            }}
            className="flex h-[215px] w-[186px] flex-col justify-between rounded-[8px] bg-[url('/images/backgrounds/button-gov.svg')] bg-cover bg-no-repeat p-5 max-lg:max-h-[160px]"
          >
            <p className="text-[56px]/[64px] font-bold text-white max-lg:text-4xl">
              1
            </p>
            <div className="flex items-center justify-between">
              <p className="text-lg text-white">{t('stake')}</p>
              <Image
                src={"/images/icons/icon-right.svg"}
                width={24}
                height={24}
                alt="icon"
              />
            </div>
          </motion.div>
          {/* </div> */}

          <motion.div
            initial={{ clipPath: "inset(100% 0 0 0)" }} // che từ dưới lên
            animate={{ clipPath: "inset(0% 0 0 0)" }} // bung ra toàn phần
            transition={{
              delay: 0.3,
              duration: 1,
              ease: [0.25, 0.46, 0.45, 0.94],
            }}
            className="flex h-[185px] w-[186px] flex-col justify-between rounded-[8px] bg-[url('/images/backgrounds/button-gov2.svg')] bg-cover bg-no-repeat p-5 max-lg:max-h-[140px]"
          >
            {/* <div className="bg-[url('/images/backgrounds/button-gov2.svg')] bg-cover bg-no-repeat w-[186px] h-[185px] p-5 flex-col justify-between rounded-[8px]"> */}
            <p className="text-[56px]/[64px] font-bold text-white max-lg:text-4xl">
              2
            </p>
            <div className="flex items-center justify-between">
              <p className="text-lg text-white">{t('vote-1')}</p>
              <Image
                src={"/images/icons/icon-right.svg"}
                width={24}
                height={24}
                alt="icon"
              />
            </div>
            {/* </div> */}
          </motion.div>

          <motion.div
            initial={{ clipPath: "inset(100% 0 0 0)" }} // che từ dưới lên
            animate={{ clipPath: "inset(0% 0 0 0)" }} // bung ra toàn phần
            transition={{
              delay: 0.6,
              duration: 1,
              ease: [0.25, 0.46, 0.45, 0.94],
            }}
            className="flex h-[156px] w-[186px] flex-col justify-between rounded-[8px] bg-[url('/images/backgrounds/button-gov3.svg')] bg-cover bg-no-repeat p-5 max-lg:max-h-[120px]"
          >
            {/* <div className="bg-[url('/images/backgrounds/button-gov3.svg')] bg-cover bg-no-repeat w-[186px] h-[156px] p-5 flex-col justify-between rounded-[8px]"> */}
            <p className="text-[56px]/[64px] font-bold text-white max-lg:text-4xl">
              3
            </p>
            <div className="flex items-center justify-between">
              <p className="text-lg text-white">{t('apply-grant')}</p>
              <Image
                src={"/images/icons/icon-right.svg"}
                width={24}
                height={24}
                alt="icon"
              />
            </div>
            {/* </div> */}
          </motion.div>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="w-1/2 max-md:w-full"
      >
        {/* <div className="w-1/2"> */}
        <Image
          src={"/images/backgrounds/bg-last-gov.png"}
          width={500}
          height={300}
          alt="background"
          className="w-full"
        />
        {/* </div> */}
      </motion.div>
    </section>
  );
};

export default VotingSection;
